export default "__VITE_ASSET__CxzpCpIq__"